import { Star } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { format } from "date-fns";
import React from "react";
import { useTranslation } from "react-i18next";

type DayCellProps = {
	dayNo: number;
	date: undefined | Date;
	colorCode: string | undefined;
  showToday?: boolean;
};
const ShiftPatternDayCell = (props: DayCellProps) => {
  const { t } = useTranslation();

  const isToday = props.date
  ? format(new Date(props.date), "yyyy-MM-dd") === format(new Date(), "yyyy-MM-dd")
    : false;

	const isSunday = props.date
		? props.date.getDay() === 0
		: false;
	const isWeekend = props.date
		? props.date.getDay() === 0 || props.date.getDay() === 6
		: false;
	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				marginRight: isSunday ? "8px" : "2px",
				flex: 1,
			}}
		>
			<Typography
				sx={{
					fontSize: "12px",
					color: isWeekend ? "#E46962" : "rgba(0,0,0,0.38)",
					lineHeight: "20px",
					fontFamily: "Roboto",
					fontWeight: "400",
				}}
			>
				{props.date ? format(new Date(props.date), "eeeee") : ""}
			</Typography>
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					justifyContent: "center",
					height: "32px",
					width: "100%",
				}}
			>
				<Box
					sx={{
						flex: 1,
						height: "32px",
						backgroundColor: props.colorCode ?? "#E0E0E0",
						borderRadius: "2px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
					}}
        >
          {props.showToday && isToday && (
            <Tooltip title={t("workers_today")} disableInteractive>
              <Star sx={{
                color: "#EFBF04",
                fontSize: "16px",
                cursor: "pointer",
              }} />
            </Tooltip>
          )}
        </Box>
			</Box>
		</Box>
	);
};

export default ShiftPatternDayCell;
